import BPSettings from "components/BPSettings";

const BPSettingsContainer = (props: any) => {
    return <BPSettings {...props} key={props.page} />;
};

export default BPSettingsContainer;
